import React, { useEffect, useState } from 'react'
import { View, Text, StyleSheet } from 'react-native'
import InputText from '../InputText'
import { IClient } from '../../../screens/ClientDetails'
import MultiselectTags from '../MultiselectTags/MultiselectTags'
import { ClientService } from '../../../services/ClientService'
import { getStyleSheet } from '../../../assets/theme/styles'
import useDimensions from '../../../hooks/useDimensions'
import { useToast } from 'react-native-toast-notifications'

const Setting = ({
    client,
    tags,
    onUpdateRow,
    setClientName,
}: {
    client: IClient
    tags: any[]
    onUpdateRow: (id: string | null, newObject: any) => void
    setClientName: (name: string) => void
}) => {
    const [valueName, setValueName] = useState('')
    const globalStyles = getStyleSheet()
    const { windowWidth } = useDimensions()
    const { createTagsInClient, deleteAllTagsInClient } = ClientService()
    const toast = useToast()

    useEffect(() => {
        setValueName(client.name)
        setClientName(client.name)
    }, [client])

    const onCellEditComplete = ({
        newValue,
        field,
        oldValue,
    }: {
        newValue: string
        field: string
        oldValue: string
    }) => {
        if (newValue.trim().length > 0) {
            if (newValue.trim() !== oldValue.trim()) {
                client[field] = newValue

                const objectUpdate = {
                    id: client.id,
                    name: newValue,
                    _version: client._version,
                }

                onUpdateRow(null, objectUpdate)
                setClientName(newValue)
            }
        }
    }

    const selectedTagsFormat = client.arrayTags.map((item: any) => {
        return {
            value: item.id,
            label: item.name,
            color: item.color.includes('#') ? item.color : '#' + item.color,
        }
    })

    const handleChangeTag = async (selectedTags: any, client: any) => {
        if (client.TagsClient.items.length > 0) {
            await deleteAllTagsInClient(client.TagsClient.items)
        }

        if (selectedTags.length > 0) {
            for (const tagTask of selectedTags) {
                const tagsTask = { clientID: client.id, tagID: tagTask.value }
                await createTagsInClient(tagsTask)
            }
            toast.show('Client was updated successfully', { type: 'success' })
        }
    }

    return (
        <View style={styles.container}>
            <View style={{ ...styles.labelContainer, width: windowWidth > 600 ? '40%' : '100%' }}>
                <Text style={{ ...styles.label, color: globalStyles.text }}>Name</Text>
                <InputText
                    containerStyle={{ flexGrow: 1 }}
                    value={valueName}
                    skeletonStyles={{ flexGrow: 1, marginRight: 10, width: 'auto' }}
                    onChange={e => {
                        setValueName(e.valueOf())
                    }}
                    onBlur={() => {
                        onCellEditComplete({
                            field: 'name',
                            newValue: valueName,
                            oldValue: '',
                        })
                    }}
                />
            </View>

            <View style={{ ...styles.labelContainer, width: windowWidth > 600 ? '40%' : '100%' }}>
                <Text style={{ ...styles.label, color: globalStyles.text }}>Tags</Text>
                <MultiselectTags
                    containerStyle={{ borderWidth: 1, borderColor: 'rgb(198, 210, 217)' }}
                    indentificator={client.id}
                    tags={tags}
                    value={selectedTagsFormat}
                    onChangeTag={value => handleChangeTag(value, client)}
                />
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        gap: 20,
    },
    labelContainer: {
        gap: 10,
    },
    label: {
        fontSize: 18,
        fontWeight: '600',
    },
})

export default Setting
